import {createSelector} from '@ngrx/store'
import {correlationIdSelector} from './samoobsluga/samoobsluga.selectors';

const selectStoreRootState = (state: any) => state;

export const correlationIdWithStoreStateSelector = createSelector(
  correlationIdSelector,
  selectStoreRootState,
  (correlationId: string, storeState: string) => {
    return {correlationId, storeState};
  });
